// SearchResultsScreen.js
import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import { API_BASE_URL } from "../Config";
import { Alert, Row, Col, Spinner, Container } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import { CartContext } from "../contexts/CartContext";
import { MaintenanceModeContext } from "../contexts/MaintenanceModeContext";
import { SvgErrorAlert } from "../components/Svgs";
import Product from "../components/Product";

import Banner from "../components/Banner"; 

function SearchResultsScreen() {
  const { t } = useTranslation();

  const { searchTerm } = useParams(); // Captura o termo da URL para pesquisa

  const fetcher = (url) => fetch(url).then((res) => res.json());

  /*const { data, error } = useSWR(`${API_BASE_URL}/api/search/${searchTerm}`, fetcher);*/
  const fetchUrl = searchTerm ? `${API_BASE_URL}/api/search/${searchTerm}/` : `${API_BASE_URL}/api/search/`;
  const { data, error } = useSWR(fetchUrl, fetcher);


  const [isLoading, setIsLoading] = useState(false);
  const maintenanceMode = useContext(MaintenanceModeContext);

  const { products, setProducts } = useContext(CartContext);

  useEffect(() => {
    setIsLoading(!error && !data); // Define carregamento apenas se não houver erro e os dados ainda não foram carregados
    if (data && data.products) {
      setProducts(data.products); // Atualiza os produtos apenas se houver dados válidos
    }
  }, [data, setProducts, error]);
  

  if (maintenanceMode) {
    return <div className="text-center pt-5">{t('website_maintenance')}</div>;
  } else if (isLoading || !products) {
    return (
      <div className="spinning">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t('loading')}</span>
        </Spinner>
      </div>
    );
  } else {
    return (
      <Container>

        <Banner />

        <h3 className="pb-md-1">{t('search')}{searchTerm ? `: ${searchTerm}` : ''}</h3>
        
        {error && (
          <Alert variant="danger">
            <SvgErrorAlert /> {t('fetch_error')}
          </Alert>
        )}

        {products && (
          <>
            <Row>
              <Col>
                <div className="text-center pb-3">
                  {products && data && data.products && (
                    <div className="text-center pb-3">
                      {t('products_found', { count: data.products.length })}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              {products.map((product) => (
                <Col
                  className="my-2 card-border"
                  sm={6}
                  md={6}
                  lg={4}
                  xl={3}
                  key={product.id}
                >
                  <Product key={product.id} product={product} sourceScreen="SearchResultsScreen" />
                </Col>
              ))}
            </Row>
          </>
        )}
      </Container>
    );
  }
}

export default SearchResultsScreen;
